// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aControl-module__frame--JDyXe {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aControl-module__frame--JDyXe .ant-tabs-nav {
  margin-bottom: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom2a/Bom2aControl/Bom2aControl.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;AAAF;AALA;EAQI,kBAAA;AAAJ","sourcesContent":[".frame {\n  height: 100%;\n  overflow: auto;\n\n  display: flex;\n  flex-direction: column;\n\n  :global(.ant-tabs-nav) {\n    margin-bottom: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aControl-module__frame--JDyXe`
};
export default ___CSS_LOADER_EXPORT___;
